import { Button } from '@antimatterhq/ui/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@antimatterhq/ui/components/dialog';

export type ConfirmationDialogProps = {
  title?: string;
  body?: string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isConfirming?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

export const ConfirmationDialog = ({
  title = 'Are you sure?',
  body,
  open,
  onConfirm,
  onCancel,
  isConfirming,
  confirmButtonText,
  cancelButtonText,
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => !isOpen && onCancel()}
      data-testid="confirmation-dialog"
    >
      <DialogContent data-testid="confirmation-dialog-content">
        <DialogHeader data-testid="confirmation-dialog-header">
          <DialogTitle data-testid="confirmation-dialog-title">
            {title}
          </DialogTitle>
        </DialogHeader>
        {body && (
          <DialogDescription data-testid="confirmation-dialog-description">
            {body}
          </DialogDescription>
        )}
        <DialogFooter data-testid="confirmation-dialog-footer">
          <DialogClose asChild>
            <Button
              variant="default"
              disabled={isConfirming}
              data-testid="confirmation-dialog-cancel-button"
            >
              {cancelButtonText || 'Cancel'}
            </Button>
          </DialogClose>
          <Button
            onClick={onConfirm}
            variant="primary"
            disabled={isConfirming}
            loading={isConfirming}
            data-testid="confirmation-dialog-confirm-button"
          >
            {confirmButtonText || 'Confirm'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
